var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { mockData as calendarsData } from '@web/lib/demo/data/calendarEvents';
import { mockData as meetingEventsData } from '@web/lib/demo/data/meetingEvents';
import { filterData, getUsers } from '@web/lib/demo/utils';
var OVERRUN_MINUTES = 30;
export var meetInsights = function (input) {
    var users = getUsers({
        orgUnitId: input.orgUnitId,
        userId: input.userId
    });
    var meetingsEvents = filterData(meetingEventsData, [
        {
            key: 'date',
            value: input.dateFrom,
            operator: 'gt'
        },
        {
            key: 'date',
            value: input.dateTo,
            operator: 'lt'
        },
        {
            key: 'userId',
            value: users.map(function (user) { return user.id; }),
            operator: 'in'
        }
    ]);
    var meetsWithMinsOverrun = meetingsEvents.reduce(function (acc, event) {
        if (acc.find(function (m) { return m.id === event.meetingId; })) {
            return acc;
        }
        if (event.meeting.overrunDurationSeconds &&
            event.meeting.overrunDurationSeconds > OVERRUN_MINUTES * 60) {
            var calendarEvent = calendarsData.find(function (c) { return c.id === event.meeting.calendarId; });
            acc.push(__assign(__assign({}, event.meeting), { calendar: calendarEvent
                    ? { title: calendarEvent.calendar.title }
                    : null, meetingGuests: event.meeting.meetingGuests.map(function (guest) { return ({
                    userId: guest.userId
                }); }) }));
        }
        return acc;
    }, []);
    return {
        meetsWithMinsOverrun: meetsWithMinsOverrun
    };
};
